<template>
  <div class="row">
    <div class="col-lg-6 col-md-12">
      <Table
        :title="$t('components.listingTable.titles.general')"
        :entries="general"
      >
        <template v-slot:iconProperties>
          <TablePropertyEntry
            :title="$t('components.listingTable.fields.properties')"
            :entries="iconProperties"
          />
        </template>
      </Table>
    </div>

    <div class="col-lg-6 col-md-12">
      <Table
        :title="$t('components.listingTable.titles.environment')"
        :entries="umgebung"
      />
      <div class="spacer" spacer="spacer-2" style="height: 40px"></div>
      <Table
        :title="$t('components.listingTable.titles.special')"
        :entries="besondere"
      >
        <TableEntry
          v-if="
            this.listing.properties.extraAdditionalProperty &&
            this.listing.properties.extraAdditionalProperty.value
          "
          key="extraAdditionalProperty"
          :text="$t('components.listingTable.fields.extraAdditionalProperty')"
        >
          <td>
            {{
              this.getLocalizedBoolDescription(
                this.listing.properties.extraAdditionalProperty
              )
            }}
          </td>
        </TableEntry>
      </Table>
      <div class="spacer" spacer="spacer-3" style="height: 40px"></div>
      <Table
        :title="$t('components.listingTable.titles.interior')"
        :entries="innenausbau"
      />
    </div>
  </div>
</template>

<script>
import Table from "@/components/table/Table";
import TablePropertyEntry from "@/components/table/TablePropertyEntry";
import TableEntry from "@/components/table/TableEntry";
export default {
  name: "ListingTable",
  components: {
    Table,
    TablePropertyEntry,
    TableEntry,
  },
  props: {
    listing: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    getLocalizedBoolDescription(localizedBoolDescription) {
      /*
      value: Boolean
      description: LocalizedString
      */
      if (
        localizedBoolDescription == null ||
        localizedBoolDescription == undefined ||
        localizedBoolDescription.value == undefined ||
        localizedBoolDescription.description == undefined
      ) {
        return undefined;
      }

      // If false, return undefined
      if (!localizedBoolDescription.value) {
        return undefined;
      }
      return this.$options.filters.localized(
        localizedBoolDescription.description
      );
    },
    getLocalizedValue(localizedObject) {
      return this.$options.filters.localized(localizedObject);
    },
    computeAddress: function (address) {
      let formattedAddress = [
        address.street,
        " ",
        address.number,
        ", ",
        address.cap,
        " ",
        address.city,
      ]
        .filter((el) => el !== undefined)
        .join("");
      return {
        title: "Adresse",
        value:
          formattedAddress +
          '<br><a href="#mapContainer" class="text-2" data-hash data-hash-offset="100">(Siehe Karte)</a>',
      };
    },
  },
  computed: {
    iconProperties: function () {
      return [
        {
          data: this.listing.properties.childrenAllowed,
          icon: "fas fa-child",
          tooltip: this.$i18n.t("properties.childrenAllowed"),
        },
        {
          data: this.listing.properties.internet.value,
          icon: "fas fa-wifi",
          tooltip: this.$i18n.t("properties.internet"),
        },
        {
          data: this.listing.properties.dogsAllowed,
          icon: "fas fa-paw",
          tooltip: this.$i18n.t("properties.dogsAllowed"),
        },
        {
          data: this.listing.properties.swimmingPool.value,
          icon: "fas fa-swimmer",
          tooltip: this.$i18n.t("properties.swimmingPool"),
        },
        {
          data: this.listing.properties.grill.value,
          icon: "fas fa-fire-alt",
          tooltip: this.$i18n.t("properties.grill"),
        },
        {
          data: this.listing.properties.wheelchairAccessible,
          icon: "fas fa-wheelchair",
          tooltip: this.$i18n.t("properties.wheelchairAccessible"),
        },
        {
          data: this.listing.properties.winterAccessible,
          icon: "fas fa-snowflake",
          tooltip: this.$i18n.t("properties.winterAccessible"),
        },
      ];
    },
    general: function () {
      let partOne = [
        {
          title: this.$i18n.t("components.listingTable.fields.objectId"),
          value: this.listing.objectId,
        },
        {
          title: this.$i18n.t(
            "components.listingTable.fields.identificationNumber"
          ),
          value: this.listing.identificationNumber,
        },
        {
          title: this.$i18n.t("components.listingTable.fields.houseType"),
          value: this.getLocalizedValue(this.listing.houseType.localizedName),
        },
        this.computeAddress(this.listing.address),
        {
          title: this.$i18n.t("components.listingTable.fields.typeOfProperty"),
          value: this.getLocalizedValue(this.listing.shortDescription),
        },
        {
          title: this.$i18n.t("components.listingTable.fields.surface"),
          value: this.listing.properties.surface,
          additional: "m<sup>2</sup>",
        },
        {
          title: this.$i18n.t("components.listingTable.fields.numberOfPeople"),
          value: this.listing.properties.numberOfPeople,
        },
        {
          title: this.$i18n.t("components.listingTable.fields.numberOfRooms"),
          value: this.listing.properties.numberOfRooms,
        },
        {
          title: this.$i18n.t(
            "components.listingTable.fields.numberOfBedrooms"
          ),
          value: this.listing.properties.numberOfBedrooms,
        },
        {
          title: this.$i18n.t(
            "components.listingTable.fields.roomsDescription"
          ),
          value: this.getLocalizedValue(
            this.listing.properties.roomsDescription
          ),
        },
        {
          title: this.$i18n.t("components.listingTable.fields.bathroomCount"),
          value: this.listing.properties.bathroomCount,
        },
        {
          title: this.$i18n.t(
            "components.listingTable.fields.bathroomDescription"
          ),
          value: this.getLocalizedValue(
            this.listing.properties.bathroomDescription
          ),
        },
        {
          title: this.$i18n.t("components.listingTable.fields.numberOfWCs"),
          value: this.listing.properties.numberOfWCs,
        },
        {
          title: this.$i18n.t("components.listingTable.fields.garden"),
          value: this.getLocalizedBoolDescription(
            this.listing.properties.garden
          ),
        },
        {
          title: this.$i18n.t(
            "components.listingTable.fields.balconyOrTerrace"
          ),
          value: this.getLocalizedBoolDescription(
            this.listing.properties.balconyOrTerrace
          ),
        },
        {
          title: this.$i18n.t("components.listingTable.fields.parking"),
          value: `${
            this.listing.properties.parkingCount
          }, ${this.getLocalizedValue(
            this.listing.properties.parkingType.localizedName
          )}`,
        },
        {
          title: this.$i18n.t(
            "components.listingTable.fields.parkingDescription"
          ),
          value: this.getLocalizedValue(
            this.listing.properties.parkingDescription
          ),
        },
        {
          title: this.$i18n.t("components.listingTable.fields.heating"),
          value: this.getLocalizedValue(
            this.listing.properties.heatingDescription
          ),
        },
        {
          title: this.$i18n.t("components.listingTable.fields.fireplace"),
          value: this.getLocalizedValue(
            this.listing.properties.fireplaceDescription
          ),
        },
      ];
      return partOne.filter(
        (el) =>
          el.value !== undefined &&
          el.value !== null &&
          el.value !== "0" &&
          el.value !== ""
      );
    },
    umgebung: function () {
      return [
        {
          value: this.getLocalizedValue(
            this.listing.properties.neighborhoodDescription
          ),
          title: this.$i18n.t("components.listingTable.fields.neighborhood"),
        },
        {
          value: this.getLocalizedValue(
            this.listing.properties.viewDescription
          ),
          title: this.$i18n.t("components.listingTable.fields.view"),
        },
        {
          value: this.getLocalizedValue(
            this.listing.properties.shoppingDescription
          ),
          title: this.$i18n.t("components.listingTable.fields.shopping"),
        },
        {
          value: this.getLocalizedValue(
            this.listing.properties.publicTransportation
          ),
          title: this.$i18n.t(
            "components.listingTable.fields.publicTransportation"
          ),
        },
      ].filter(
        (el) =>
          el.value !== undefined &&
          el.value !== null &&
          el.value !== "0" &&
          el.value !== ""
      );
    },
    besondere: function () {
      return [
        {
          value: this.getLocalizedBoolDescription(
            this.listing.properties.television
          ),
          title: this.$i18n.t("components.listingTable.fields.television"),
        },
        {
          value: this.getLocalizedBoolDescription(
            this.listing.properties.internet
          ),
          title: this.$i18n.t("components.listingTable.fields.internet"),
        },
        {
          value: this.getLocalizedBoolDescription(
            this.listing.properties.swimmingPool
          ),
          title: this.$i18n.t("components.listingTable.fields.swimmingPool"),
        },
        {
          value: this.listing.properties.grill.value,
          title: this.$i18n.t("components.listingTable.fields.grill"),
          additional: (() => {
            const grillDescription = this.getLocalizedBoolDescription(
              this.listing.properties.grill
            );

            return !this.isUndefined(grillDescription) &&
              grillDescription.trim() !== ""
              ? `, ${grillDescription}`
              : undefined;
          })(),
        },
        {
          value: this.getLocalizedBoolDescription(
            this.listing.properties.washingMachine
          ),
          title: this.$i18n.t("components.listingTable.fields.washingMachine"),
        },
      ].filter(
        (el) =>
          el.value !== undefined &&
          el.value !== null &&
          el.value !== "0" &&
          el.value !== ""
      );
    },
    innenausbau: function () {
      return [
        {
          title: this.$i18n.t("components.listingTable.fields.kitchen"),
          value: this.getLocalizedValue(this.listing.properties.kitchen),
        },
        {
          title: this.$i18n.t("components.listingTable.fields.cookingSurface"),
          value: this.getLocalizedValue(this.listing.properties.cookingSurface),
        },
        {
          title: this.$i18n.t("components.listingTable.fields.dishwasher"),
          value: this.listing.properties.dishwasher,
        },
      ].filter(
        (el) =>
          el.value !== undefined &&
          el.value !== null &&
          el.value !== "0" &&
          el.value !== ""
      );
    },
  },
};
</script>
